import Component from "../core/Component"
import { scrollToElement } from "../services/Scroll"
import { queryAll } from "../utils/dom"

export default class Page extends Component {
    constructor(element, options) {
        super(element, (options = {}))

        this.triggerClick = {
            activeId: null,
            elements: [],
        }
    }

    prepare() {
        this.element.addEventListener("click", this.handleClick)

        const syncHover = createSynchronizedHover(this.element)
        syncHover.prepare()
    }

    handleClick = (event) => {
        if (event.defaultPrevented) {
            return
        }
        let target = null

        target = event.target.closest("[data-trigger-click]")
        if (target) {
            this.processClickTrigger(target)
            return
        }

        target = event.target.closest("a")
        if (target) {
            this.processClickATag(target)
            return
        }
    }

    processClickATag(target) {
        const type = Object.prototype.toString.call(target.href)
        let href = target.dataset.href ? target.dataset.href : type === "[object SVGAnimatedString]" ? target.href.baseVal : target.href
        if (href.startsWith('#')) {
            const url = new URL(window.location.href)
            url.hash = href
            href = `${url}`
        }

        if (document.location.href.split("#")[0] !== href.split("#")[0]) {
            return
        }

        const id = href.split("#")[1]
        if (!id) {
            return
        }

        const element = document.getElementById(id)
        if (!element) {
            return
        }

        event.preventDefault()

        let offset = target.dataset.offset ? target.dataset.offset : 0
        let mode = target.dataset.mode ? target.dataset.mode : "force-center"
        let shouldReplaceUrl = target.dataset.replaceUrl === "true"

        const toggleBlock = this.getToggleBlockComponent(element)
        if (toggleBlock) {
            const options = JSON.parse(target.dataset.toggleblockOptions || "{}")
            const action = options.action ?? "open"
            toggleBlock[action](options, {})
        } else {
            console.log(mode)
            scrollToElement(element, { offset, mode })
        }

        if (shouldReplaceUrl) {
            const url = new URL(location.href)
            url.hash = id
            history.replaceState('','',url)
        }
    }

    processClickTrigger(target) {
        const id = target.dataset.triggerClick?.replace("#", "")
        if (!id) {
            return
        }

        const link = document.getElementById(id)
        if (!link) {
            return
        }

        link.click()
    }

    getToggleBlockComponent(element) {
        const toggleBlockEl = element.closest('[data-component="ToggleBlock"]')

        if (toggleBlockEl) {
            const toggleBlock = Component.getFromElement(toggleBlockEl)
            return toggleBlock
        }

        return null
    }
}

function createSynchronizedHover(element) {
    let activeId = null
    let elements = []

    const prepare = () => {
        element.addEventListener("mouseover", handleMouseOver)
    }

    const clear = () => {
        if (activeId) {
            elements.forEach((element) => {
                element.classList.remove("is-hover")
            })
            activeId = null
            elements = []
        }
    }

    const handleMouseOver = (event) => {
        const linkEl = event.target.closest("[data-trigger-click], a[id]")
        if (!linkEl) {
            clear()
            return
        }

        const id = linkEl.dataset.triggerClick ?? linkEl.id
        if (activeId === id) {
            return
        }

        clear()
        elements = queryAll(`[data-trigger-click="${id}"], [id="${id}"]`)
        elements.forEach(element => {
            element.classList.add("is-hover")
        })
        activeId = id
    }

    return {
        prepare
    }
}
